<template>
<div class='slide slide--discussion'>
  <div class='slide_label body-four-light'>
    {{ activity.label || $t('discussion') }}
  </div>

  <h2 class='slide_headline h-two-light'>
    {{ activity.headline }}
  </h2>

  <div
    v-if='activity.subheadline'
    class='slide_subheadline body-one-light'
    v-html='activity.subheadline'
  />

  <button
    class='slide_cta button-one-light'
    @click.prevent='toggleOverlay()'
  >
    {{ activity.cta }}
  </button>
</div>
</template>

<script>
import CommonMixin from './common-mixin'

export default {
  mixins: [CommonMixin],

  methods: {
    toggleOverlay() {
      if (this.is_authenticated) {
        this.toggleActivityOverlay()
        this.updateResult('clicked')
      } else {
        this.toggleSignInOverlay()
      }
    }
  }
}
</script>

<style lang='sass' scoped>
// @import './discussion-v1'
</style>
